import { Pipe, PipeTransform } from '@angular/core';
import { getFormatDate } from '../../helpers/date-helpers';

@Pipe({
  name: 'dayToString',
  standalone: false,
})
export class DayToStringPipe implements PipeTransform {
  transform(day: number) {
    const weekday = new Array(7);
    weekday[0] = $localize`:@@day.sunday:Sunday`;
    weekday[1] = $localize`:@@day.monday:Monday`;
    weekday[2] = $localize`:@@day.tuesday:Tuesday`;
    weekday[3] = $localize`:@@day.wednesday:Wednesday`;
    weekday[4] = $localize`:@@day.thursday:Thursday`;
    weekday[5] = $localize`:@@day.friday:Friday`;
    weekday[6] = $localize`:@@day.saturday:Saturday`;
    return weekday[day];
  }
}

@Pipe({
  name: 'monthToString',
  standalone: false,
})
export class MonthToStringPipe implements PipeTransform {
  transform(month: number) {
    const monthFull = new Array(12);
    monthFull[0] = $localize`:@@month.january:January`;
    monthFull[1] = $localize`:@@month.february:February`;
    monthFull[2] = $localize`:@@month.march:March`;
    monthFull[3] = $localize`:@@month.april:April`;
    monthFull[4] = $localize`:@@month.may:May`;
    monthFull[5] = $localize`:@@month.june:June`;
    monthFull[6] = $localize`:@@month.july:July`;
    monthFull[7] = $localize`:@@month.august:August`;
    monthFull[8] = $localize`:@@month.september:September`;
    monthFull[9] = $localize`:@@month.october:October`;
    monthFull[10] = $localize`:@@month.november:November`;
    monthFull[11] = $localize`:@@month.december:December`;
    return monthFull[month];
  }
}

@Pipe({
  name: 'formatDate',
  standalone: false,
})
export class formatDatePipe implements PipeTransform {
  transform(date: Date) {
    return getFormatDate(date);
  }
}
